import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import AutoComplete from "rsuite/AutoComplete";
import ReactPaginate from "react-paginate";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { BsSearch } from "react-icons/bs";

function Promo() {
  const [data, setData] = useState([]);
  const [autoComplete, setAutoComplete] = useState([]);
  const [search, setsearch] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState();
  const [getDataSuccess, setgetDataSuccess] = useState(false);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [modalShow, setModalShow] = useState(false);
  const [idPromo, setIdPromo] = useState();

  const getData = async () => {
    const result = await axios.get("https://mobile.amospa.com/promo");
    const title = result.data.data.map((value) => value.title);
    setAutoComplete(title);
    setData(result.data.data);
    setgetDataSuccess(true);
  };

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  useEffect(() => {
    getData();
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [deleteSuccess, itemOffset, itemsPerPage, getDataSuccess]);

  //Handle search
  const keys = ["title"];
  const handleSearch = () => {
    return search
      ? data.filter((item) => keys.some((key) => item[key].includes(search)))
      : false;
  };

  const promo = handleSearch();
  const dataTable = promo ? promo : currentItems;

  //Handle Delete
  const deleteSpa = async (id) => {
    setIdPromo(id);
    setModalShow(true);
  };

  //Handle Next
  const handleNext = async () => {
    const result = await axios.delete(
      `https://mobile.amospa.com/promo/${idPromo}`
    );
    setDeleteSuccess(result);
    setModalShow(false);
    window.location.reload();
  };

  return (
    <div className="wrapper-spa">
      <div className="users-mobile">
        <div className="header-cafe py-4">
          <span className="d-flex align-items-center">
            <h3 className="mx-2 text-white">List Promo</h3>
            <p>
              <select onChange={(e) => setitemsPerPage(e.target.value)}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </p>
          </span>
          <span className="d-flex">
            <Link to={"/homepage/promo/add"}>
              <button
                className="btn rounded-3 me-2 fw-bold"
                style={{ background: "#FFD700" }}
              >
                ADD Promo
              </button>
            </Link>
            <span className="d-flex align-items-center list-search bg-light rounded-3 ps-1 me-2">
              <BsSearch color="black" fontSize="20px" />
              <AutoComplete
                placeholder="Search . . ."
                id="rs-input"
                onChange={(e) => setsearch(e)}
                data={autoComplete}
              />
            </span>
          </span>
        </div>
        <div className="table-users-mobile">
          <Table striped bordered hover className="m-0">
            <thead>
              <tr>
                <th>No</th>
                <th>Title</th>
                <th>Price</th>
                <th>Image</th>
                <th>Description</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {dataTable.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item ? item.title : ""}</td>

                  <td>{item ? item.price : ""}</td>

                  <td>
                    <img src={item ? item.image : ""} alt="" />
                  </td>

                  <td>{item ? item.description : ""}</td>

                  <td className="d-flex">
                    <Link to={`/homepage/promo/${item.id}`}>
                      <button
                        className="btn-staffid ms-2 bg-warning text-dark py-1 px-3"
                        style={{ borderRadius: "10px" }}
                      >
                        Edit
                      </button>
                    </Link>
                    <button
                      className="btn-staffid ms-2 bg-danger px-2 py-1"
                      onClick={() => deleteSpa(item.id)}
                      style={{ borderRadius: "10px" }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        <div className="footer-role p-2 py-3">
          <p>
            Showing {currentItems.length} to {data.length} Entries
          </p>
          <div>
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              containerClassName="pagination"
              pageLinkClassName="page-num"
              previousLinkClassName="page-num"
              nextLinkClassName="page-num"
              activeLinkClassName="active"
            />
          </div>
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Delete Promo ?"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Promo;
